export const selectCustomStyle = {
  control: (provided) => ({
    ...provided,
    minHeight: "45px",
    height: "45px",
    alignItems: "center",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "45px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (provided) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)", // Centers the placeholder vertically
    width: "100%",
    margin: 0,
    padding: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)", // Centers the selected value vertically
    width: "100%",
    margin: 0,
    padding: 0,
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    height: "100%",
    display: "flex",
    alignItems: "center", // Centers the input text when typing
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "45px",
    padding: "0 8px", // Adjust padding as needed
    display: "flex",
    alignItems: "center", // Centers the content
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
};
